import { _ as _defineProperty } from '../../defineProperty-18999f8e.js';
import getNotRotatedCoords from '../getNotRotatedCoords/index.js';
import degreeToRadian from '../degreeToRadian/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var sin = Math.sin,
    sqrt = Math.sqrt,
    pow = Math.pow,
    atan = Math.atan,
    cos = Math.cos;

// TODO add description for this function
function getRotatedPoint(_ref) {
  var pointX = _ref.x,
      pointY = _ref.y,
      centerX = _ref.centerX,
      centerY = _ref.centerY,
      rotation = _ref.rotation;
  var rotationRadian = degreeToRadian(rotation);
  var pointRadius = sqrt(pow(pointX - centerX, 2) + pow(pointY - centerY, 2));
  var betta = atan((pointY - centerY) / (pointX - centerX));
  var gamma = degreeToRadian(90) + rotationRadian / 2 - betta;
  var pointsDistance = sqrt(2 * pow(pointRadius, 2) * (1 - cos(rotationRadian)));
  var diffX = cos(gamma) * pointsDistance;
  var diffY = sin(gamma) * pointsDistance;

  if (pointX < centerX) {
    return {
      x: pointX - diffX,
      y: pointY + diffY
    };
  }

  return {
    x: pointX + diffX,
    y: pointY - diffY
  };
}

var hasIntersectionWithPoint = function hasIntersectionWithPoint(targetRect, point) {
  var width = targetRect.width,
      height = targetRect.height,
      _targetRect$rotation = targetRect.rotation,
      rotation = _targetRect$rotation === void 0 ? -0 : _targetRect$rotation;
  var angle = rotation < 0 ? 180 + rotation : rotation;

  var _getNotRotatedCoords = getNotRotatedCoords(_objectSpread(_objectSpread({}, targetRect), {}, {
    rotation: -angle
  })),
      x = _getNotRotatedCoords.x,
      y = _getNotRotatedCoords.y,
      centerX = _getNotRotatedCoords.centerX,
      centerY = _getNotRotatedCoords.centerY;

  var rotatedPoint = getRotatedPoint(_objectSpread(_objectSpread({}, point), {}, {
    centerX: centerX,
    centerY: centerY,
    rotation: angle
  }));
  return rotatedPoint.x < x + width && rotatedPoint.y < y + height && rotatedPoint.x > x && rotatedPoint.y > y;
};

export { hasIntersectionWithPoint as default };
